import { useQueryParamValue } from 'src/app/shared/hooks/location';

export function useIsVenmoQREnabled(): boolean {
	const param = useQueryParamValue('v_qr_code') || 'false';
	return param === 'true';
}
